class LevelLoader

  constructor: (stage) ->
    @blocksize = 30
    @stage = stage
    @easystar = new EasyStar.js()

  makeLevel: (currentLevel, cb) ->
    currentLevel = ("000" + currentLevel).substr(-3,3)
    level = $.ajax "data/level#{currentLevel}.txt"
    level.then (data) =>
      rows = data.split('\n')
      grid = rows.map (x) -> x.split(' ')

      tiles = []
      filename = "rock.png"
      for row, r in grid
        for col, c in row
          if col is "1"
            image = new createjs.Bitmap("./data/#{filename}")
            tile =
              image : image
              x     : @blocksize * c
              y     : @blocksize * r
            tiles.push tile

      @easystar.setGrid grid

      acceptableTiles = _(grid)
        .flatten()
        .uniq (c) -> c.charCodeAt 0
        .filter (x) -> x isnt "1"
        .value()
      @easystar.setAcceptableTiles acceptableTiles

      @easystar.setIterationsPerCalculation 100

      @wid       = grid[0].length
      @hei       = grid.length
      canvas     = $("canvas")
      @scrWidth  = canvas.width()
      @scrHeight = canvas.height()

      cb tiles

module.exports = LevelLoader
